<template>
  <section>
    <form action>
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">{{headerText}}</p>
        </header>
        <section class="modal-card-body">
          <b-message type="is-info">
            Hallo {{ nicknameValue }},
            <br>hier kannst du die Anzahl deiner Kaffees zurücksetzen, nachdem du entweder in Bar oder per Paypal bezahlt hast.
            Falls dein bezahlter Betrag über den erechneten Betrag hinausgeht, wird dir die Anzahl der Kaffee's gutgeschrieben.
          </b-message>

          <div class="columns is-mobile">
            <div class="column">
              <strong>Errechneter Betrag</strong>
              <h1 class="title is-primary">{{ totalPrice | localCurrencyEur }}</h1>
              <b-field label="Bezahlter Betrag">
                <b-input size="is-large" type="number is-large" v-model="payedPriceValue" :min="1"></b-input>
              </b-field>
              <span>
                Anzahl Kaffees nach Speichern: {{ calcedCoffeeAmount }}
                <span v-if="calcedCoffeeAmount < 0">(Gutschrift)</span>
              </span>
            </div>
            <div class="column">
              <b-message>
                <span>Link zu Paypal</span>
                <p>
                  <img :src="qrCode">
                </p>
              </b-message>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="$parent.close()">Abbrechen</button>
          <button
            class="button is-success"
            :disabled="payedPriceValue <= 0"
            type="button"
            @click="save()"
          >Speichern</button>
        </footer>
      </div>
    </form>
  </section>
</template>

<script>
import Store from "../store";
import QRCode from "qrcode";
import moment from "moment";

export default {
  name: "paymentForm",
  props: ["nickname", "amount", "pricePerCoffee"],
  data() {
    return {
      headerText: "Anzahl anpassen",
      nicknameValue: "",
      amountValue: 0,
      totalPrice: 0,
      payedPriceValue: '',
      isGenerating: false,
      qrCode: "dummy"
    };
  },
  filters: {
    localCurrencyEur: function(value) {
      return value
        ? value.toLocaleString(moment.locale(), {
            style: "currency",
            currency: "EUR",
            currencyDisplay: "symbol"
          })
        : "";
    }
  },
  watch: {
    payedPriceValue: function(val) {
      this.generateQrCode(val).catch(err => console.log(err));
    }
  },
  computed: {
    calcedCoffeeAmount: function() {
        const cleanedPriceValue = this.payedPriceValue.replace(",", ".");
        return this.amount - Math.floor(parseFloat(cleanedPriceValue || 0) / this.pricePerCoffee);
    }
  },
  methods: {
    generateQrCode: async function(val) {
      const url = `https://www.paypal.me/VS6Coffeelist/${val}`;
      this.qrCode = await QRCode.toDataURL(url);
    },
    save: async function() {
      await this.updateAmount();
    },
    updateAmount: async function() {
      console.log(
        `Update amount of nickname ${this.nickname} to ${this.calcedCoffeeAmount}`
      );
      await Store.dispatch("updateCoffeeAmount", {
        nickname: this.nickname,
        amount: this.calcedCoffeeAmount
      });
      this.$parent.close();
    }
  },
  mounted() {
    this.totalPrice = parseFloat(this.amount || 0) * this.pricePerCoffee;
    this.nicknameValue = this.nickname;
    this.headerText = "Bezahlen";
    this.payedPriceValue = this.totalPrice.toLocaleString(moment.locale());
    this.generateQrCode("").catch(err => console.log(err));

  }
};
</script>
